export default {
  addToQueue: {
    en: 'Add to queue',
  },
  addToCart: {
    en: 'Add to cart',
  },
  totalPurchases: {
    en: '{count} bought',
  },
}
